module.exports = __webpack_public_path__ + "img/resolute.649f4a15.webp";